import React, { useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import './Notifications.css';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Table } from 'antd';
import { NotificationsActionHandler } from '../../Redux/Actions/user/NotificationsList';
import { NotificationsReadActionHandler } from '../../Redux/Actions/user/NotificationsRead';
import Loader from "../../Components/Loader/Loader";
import { Link } from 'react-router-dom';
const notification1Icon = '/assets/notification-1.svg';
const notificationsuserIcon = '/assets/notifications_user.png';
const trueIcon = "/assets/Check-mark.svg";
const Close_Fill = "/assets/Close_Fill.svg";
const processing = "/assets/04-hold on.gif"
const Notifications = () => {
    let dispatch = useDispatch();
    const notificationsData = useSelector(
        (state) => state?.NotificationsData?.notifications_data
    );
    const notificationsReadData = useSelector(
        (state) => state?.NotificationsReadData?.notifications_read_data
    );
    const fetchData = async () => {
        try {
            dispatch(NotificationsActionHandler());
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const formatTimestamp = (timestamp) => {
        return timestamp
            ? formatDistanceToNow(new Date(timestamp), { addSuffix: true })
            : '';
    };

    const columns = [
        {
            title: 'Notification Message',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <div className='notifications-table-content'>
                    <img
                        // src={record.type=== "ACTION_RUN" ? trueIcon : notificationsuserIcon}
                        src={
                            record.action_run_status === "SUCCESS" ? trueIcon :
                                record.action_run_status === "PROCESSING" ? processing :
                                    record.action_run_status === "FAILED" ? Close_Fill :
                                        notificationsuserIcon
                        }
                        alt={'avatar'}
                        height={30}
                        width={30}
                    />
                    <span
                        className={
                            record.read_at === null
                                ? 'notifications-table-unread'
                                : ''
                        }>
                        {record.title}
                    </span>
                </div>
            ),
        },
        {
            title: 'Timestamp',
            dataIndex: 'read_at',
            key: 'read_at',
            render: (text, record) => formatTimestamp(record.read_at),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                record.type === "ACTION_RUN" ?
                    <div
                        className='notifications-table-actions'>

                        {record.action_run_status === "PROCESSING" && record.type === 'ACTION_RUN' && (
                            <>
                                <span className="view-output disabled-link mr-0">View Output</span>
                            </>
                        )}

                        {record.action_run_status !== "PROCESSING" && record.type === 'ACTION_RUN' && (
                            <>
                                <Link to={`/workspaces/runQuickActionHistory/${record?.additional_description?.action_run_id}/${record?.additional_description?.quick_action_id}`} className="view-output mr-0" onClick={record?.read_at === null ? () => handleNotificationsread(record) : () => {}}>View Output</Link>
                            </>
                        )}

                    </div>
                    :
                    <div
                        className='notifications-table-actions'
                        onClick={() => handleNotificationsread(record)}>
                        <Button className='notifications-view-request' disabled={record.read_at}>
                            Mark As Read
                        </Button>
                    </div>
            ),
        },
    ];

    const handleNotificationsread = (item) => {
        if(item?.read_at === null){
        dispatch(NotificationsReadActionHandler(item?.id));
        }
    };
    const rowClassName = (record) => {
        return record.read_at === null ? 'conditional-row-style' : '';
    };
    useEffect(() => {
        if (notificationsReadData) {
            fetchData();
        }
    }, [notificationsReadData]);
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            {notificationsData ? <div className='notifications-main'>
                <div className='notifications-container'>
                    <div className='notifications-icon'>
                        <img src={notification1Icon} alt='' />
                        <p>Notifictions</p>
                    </div>
                </div>
                <div className='main-notifications-div'>
                    <div className='notifications-front-page'>
                        <div className='notifications-mt-30'>
                            <Table
                                columns={columns}
                                dataSource={notificationsData?.data}
                                rowClassName={rowClassName}
                                // bordered
                                size='middle'
                                pagination={{
                                    pageSize: notificationsData?.per_page,
                                }}
                                className='mytable'
                            />
                        </div>
                    </div>
                </div>
            </div> : <Loader />}
        </>
    );
};
export default Notifications;
